@for (step of steps; track step; let i = $index) {
    @if (i !== 0) {
        <div
            class="step-separator-left"
            [class]="WorkflowStepStatus[getLeftSeparatorWorkflowStatus(i)]"
        ></div>
    }
    <div [class]="['step-item', WorkflowStepStatus[step.status]].join(' ')">
        <div
            [cerrixHover]="step.infoTitle || step.stepDetails ? hoverCard : null"
            [cerrixHoverClass]="'cerrix-workflow-bar-hover ' + WorkflowStepStatus[step.status]"
            [delay]="0"
            class="step-circle"
        >
            <ng-template #hoverCard>
                <div class="step-popup-container">
                    <div class="title">{{ step.infoTitle }}</div>
                    @if (step.stepDetails) {
                        <div class="step-info-container">
                            @for (details of step.stepDetails; track details) {
                                <div class="info-key">{{ details.key }}</div>
                                <div class="info-values">
                                    @for (value of details.values; track value) {
                                        <div class="info-value">
                                            {{ value }}
                                        </div>
                                    }
                                </div>
                            }
                        </div>
                    }
                </div>
            </ng-template>
        </div>
        <div class="step-title">
            {{ step.name }}
        </div>
    </div>
    @if (i !== steps.length - 1) {
        <div class="step-separator-right" [class]="WorkflowStepStatus[step.status]"></div>
    }
}
